import React, { useState, useCallback, useEffect } from "react";
import Header from "../../../../Layouts/Components/Header";
import CustomButton from "../../../shared/CustomButton";
import ModalForm from "../../../shared/ModalForm";
import { useFormik, FormikProvider } from "formik";
import {
  getMessageTypes,
  getTemplates,
  getConfiguration,
  DeleteTheCustomer,
  getGroups,
  EditGroupUser,
  AddGroupUser,
  LoadSubscribers,
  Resetnotification,
  SelectedUser,
  CheckTheStatus,
} from "../../state/alertActions";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import CustomerForm from "./CustomerForm";
import CustomersList from "./CustomersList";
import useSnackBar from "../../../Hooks/useSnackBar";
import ScreenLoader from "../../../shared/ScreenLoader";
import SideDrawerForm from "../../../shared/SideDrawerForm";
import SideCustomerForm from "./SideCustomerForm";
import CustomerFilter from "./CustomerFilter";
import { Modal } from "@mui/material";
import ModalAlerts from "../../../shared/DeleteModal";
import {
  notificationType,
  sendingType,
  direction,
  docType,
  saftyType,
  customerType,
} from "../../../../utils/constantDropdowns";
const Customers = () => {
  const [openForm, setOpenForm] = useState(false);
  const [touched, setTouched] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [customerId, setCutomerId] = useState(null);

  const userStatus = [
    { id: "All", value: "All", label: "All" },
    { id: "ACTIVE", value: "Active", label: "Active" },
    { id: "INACTIVE", value: "InActive", label: "InActive" },
  ];
  const [filterValue, setFilterValue] = useState(userStatus[0]);

  const dispatch = useDispatch();
  const { success, error, snackbar } = useSnackBar();
  const loadMessageType = useCallback(
    () => dispatch(getMessageTypes(error)),
    [error, dispatch]
  );
  const loadTemplates = useCallback(
    () => dispatch(getTemplates(error)),
    [error, dispatch]
  );
  const loadGroups = useCallback(
    () => dispatch(getGroups(error)),
    [dispatch, error]
  );
  const {
    messageTypes,
    NotificationTemplates,
    Groups,
    selectedUser,
    configData,
  } = useSelector((state) => state.CustomerList);
  let defaultTemplate = NotificationTemplates.filter(
    (temp) => temp.isDefault
  )[0];
  const loadConfiguration = useCallback(
    () => dispatch(getConfiguration(error)),
    [dispatch, error]
  );

  const handleDelete = (id) => {
    setCutomerId(id);
    setOpenDeleteModal(true);
    setDrawer(false);
  };
  const CheckStatus = (data) => {
    dispatch(CheckTheStatus(data, success, error)).then(() => {
      dispatch(
        LoadSubscribers(
          {
            pageNumber: 1,
            pageSize: 10,
          },
          error
        )
      );
      setDrawerClose();
    });
  };

  const DeleteCustomer = () => {
    dispatch(DeleteTheCustomer(customerId, success, error)).then(() => {
      dispatch(
        LoadSubscribers(
          {
            pageNumber: 1,
            pageSize: 10,
          },
          error
        )
      );
      setDrawerClose();
      setOpenDeleteModal(false);
      setCutomerId(null);
    });
  };

  useEffect(() => {
    loadMessageType();
    loadTemplates();
    loadGroups();
    loadConfiguration();
    dispatch(
      LoadSubscribers(
        {
          pageNumber: 1,
          pageSize: 10,
        },
        error
      )
    );

    return () => {
      dispatch(Resetnotification());
    };
  }, [
    loadMessageType,
    loadTemplates,
    loadGroups,
    loadConfiguration,
    error,
    dispatch,
  ]);

  const handleOpenForm = () => {
    setOpenForm(true);
    formik.resetForm();
    setTouched(false);
  };

  const handleCloseForm = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpenForm(false);
    formik.resetForm();
    setTouched(false);
  };

  const Reset = () => {
    formik.resetForm();
    setTouched(false);
  };

  const validationSchema = yup.object().shape({
    AccountNo: yup
      .string()
      .nullable()
      .required("Account No. is required")
      .min(
        configData?.accountLength,
        `Must be exactly ${configData?.accountLength} digits`
      )
      .max(
        configData?.accountLength,
        `Must be exactly ${configData?.accountLength} digits`
      ),
    customerName: yup.string().nullable().required("customer Name is required"),
    customerType: yup.string().required("customer Type is required").nullable(),
    notificationType: yup
      .string()
      .required("notification Type is required")
      .nullable(),

    MT: yup.array().of(
      yup.object().shape({
        direction: yup
          .string()
          .nullable()
          .test("required", "direction is required", (value, context) => {
            return context.from[1].value.customerType === "INDIVIDUAL" && !value
              ? false
              : true;
          }),
        messageNumber: yup
          .mixed()
          .nullable()
          .test("required", "messageType is required", (value, context) => {
            return context.from[1].value.customerType === "INDIVIDUAL" && !value
              ? false
              : true;
          }),

        /*  messageNumber: yup.string().nullable().when('customerType', (customerType) => {
      if (customerType === "indivdual") { 
          return yup.string().required("messageType is required").nullable()
      }
  }),
  direction:yup.string().nullable().test('required', "direction is required" , (value, context) => {
    
    return context.from[1].value.customerType==="indivdual" ? true : false
  
  }),
  messageNumber:yup.mixed().nullable().test('required', "messageType is required" , (value, context) => {
    debugger
    return context.from[1].value.customerType  === "indivdual"
  
  }),
 
   // messageNumber:yup.string().required(" messageType is required").nullable(),
     //direction:yup.string().nullable().required("direction is required"),
    // Rest of your amenities object properties
    //messageNumber:yup.array().min(1).required().nullable(),
      */
      })
    ),

    customerGroup: yup
      .array()
      .nullable()
      .when("customerType", (customerType) => {
        if (customerType === "GROUP") {
          return yup
            .array()
            .min(1, "Customer Group field must have at least 1 items")
            .required()
            .nullable();
        }
      }),
    //  sendingType:yup.string().nullable().required(),
    //direction:yup.string().nullable().required(),
    email: yup
      .string()
      .email()
      .when("notificationType", (notificationType) => {
        if (notificationType === "EMAIL" || notificationType === "BOTH") {
          return yup.string().email().required();
        }
      }),
    phone: yup.string().when("notificationType", (notificationType) => {
      if (notificationType === "SMS" || notificationType === "BOTH") {
        return yup.string().required();
      }
    }),
    password: yup.string().when("customerSafty", (customerSafty) => {
      if (customerSafty === "PROTECTED") {
        return yup.string().required();
      }
    }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      AccountNo: selectedUser.account || "",
      customerName: selectedUser.name || "",
      customerGroup: selectedUser?.groups?.map((group) => group) || [],
      customerType: selectedUser.type || customerType[1],
      notificationType: selectedUser.notificationType || notificationType[0],
      email: selectedUser.email || "",
      status: selectedUser.status || "",
      customerId: selectedUser.id || "",
      emailcc: selectedUser.emailCC || "",
      phone: selectedUser.phoneNumber || "",
      otherAccounts: selectedUser?.otherAccounts || [],
      docType: selectedUser.documentType || docType[0],
      customerSafty: selectedUser.safety || saftyType[0],
      password: selectedUser.password || "",
      MT:
        selectedUser?.criteria?.length > 0
          ? selectedUser?.criteria?.map((mt) => ({
              messageNumber: messageTypes.filter(
                (type) => type.id === mt.messageTypeId
              )[0],
              sendingType: mt.sendingType || sendingType[2],
              direction: mt.way || "",
              notificationTemplate:
                NotificationTemplates.filter(
                  (temp) => temp.id === mt.templateId
                )[0] || defaultTemplate,
            }))
          : [
              {
                messageNumber: null,
                sendingType: sendingType[2],
                direction: "",
                notificationTemplate: defaultTemplate,
              },
            ],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let customerInfo = {
        id: values.customerId,
        name: values.customerName,
        account: values.AccountNo,
        otherAccounts: values.otherAccounts,
        notificationType: values.notificationType,
        email: values.email,
        emailCC: values.emailcc,
        phoneNumber: values.phone,
        documentType: values.docType,
        safety: values.customerSafty,
        password: values.password,
        type: values.customerType,
        groupIds: values.customerGroup.map((group) => group.id),
        criteria:
          values.customerType === "GROUP"
            ? []
            : values?.MT.map((mt) => ({
                templateId: mt.notificationTemplate.id,
                messageTypeId: mt.messageNumber.id,
                way: mt.direction,
                sendingType: mt.sendingType,
              })),
      };

      if (values.customerId) {
        dispatch(EditGroupUser(customerInfo, success, error)).then(() => {
          dispatch(
            LoadSubscribers(
              {
                pageNumber: 1,
                pageSize: 10,
              },
              error
            )
          );
        });
        setDrawerClose();
      } else {
        dispatch(AddGroupUser(customerInfo, success, error)).then(() => {
          dispatch(
            LoadSubscribers(
              {
                pageNumber: 1,
                pageSize: 10,
              },
              error
            )
          );
        });

        setOpenForm(false);
      }

      /* 
     if(values.customerId)
      {
        if(values.customerType === "INDIVDUAL"){
          let customerDataSingleEdit = {   
            id:values.customerId,
            customerName:values.customerName,
            bankRef:values.AccountNo,
            email:values.email || '',
            status:values.status,
            notificationType:values.notificationType,
            phone:values.phone || '',   
      subscriberType:values.customerType,
      emailCc:values.emailcc,
      docType:values.docType,
      subscriberSafety:values.customerSafty,
      emailPassword:values.password || '',
      otherAccounts:values.otherAccounts || [],
      omnis:values.MT.map((mt) =>({
      templateId:mt.notificationTemplate.id,
      messageType:{id:mt.messageNumber.id,name:mt.messageNumber.name},
      direction:mt.direction,
      timingType:mt.sendingType
      }))
      }

      dispatch(EditGroupUser(customerDataSingleEdit, success, error)).then(() => {
        dispatch(LoadSubscribers(
          {
          pageNumber:1,
          pageSize:10
        },error))
      })
        }
        else{
          let customerDataGroupEdit = {
            id:values.customerId,
            customerName:values.customerName,
            bankRef:values.AccountNo,
            email:values.email || '',
            status:values.status,
            notificationType:values.notificationType,
            phone:values.phone || '',
            emailCc:values.emailcc,
          docType:values.docType,
          subscriberType:values.customerType,
          subscriberSafety:values.customerSafty,
          emailPassword:values.password,
          otherAccounts:values.otherAccounts,
          subscriberGroups:values.customerGroup.map((group) =>({"id":group.id}))
          }
          dispatch(EditGroupUser(customerDataGroupEdit, success, error)).then(() => {
            dispatch(LoadSubscribers(
              {
              pageNumber:1,
              pageSize:10
            },error))
          })
        }



        setDrawerClose()
         } 
         else {

          if(values.customerType === "INDIVDUAL")
          {
    let customerDataSingle = {   
      customerName:values.customerName,
      bankRef:values.AccountNo,
      email:values.email || '',
      status:activeUser,
      notificationType:values.notificationType,
      phone:values.phone || '',   
subscriberType:values.customerType,
emailCc:values.emailcc,
docType:values.docType,
subscriberSafety:values.customerSafty,
emailPassword:values.password || '',
otherAccounts:values.otherAccounts || [],
omnis:values.MT.map((mt) =>({
templateId:mt.notificationTemplate.id,
messageType:{id:mt.messageNumber.id , name:mt.messageNumber.name},
direction:mt.direction,
timingType:mt.sendingType
}))
}

dispatch(AddSingleUser(customerDataSingle,success,error)).then(()=>{
  dispatch(LoadSubscribers(
    {
      pageNumber:1,
    pageSize:10
  },error))
})

}
else{
let customerData = {
  customerName:values.customerName,
  bankRef:values.AccountNo,
  email:values.email || '',
  status:activeUser,
  notificationType:values.notificationType,
  phone:values.phone || '',
  emailCc:values.emailcc,
  subscriberType:values.customerType,
docType:values.docType,
subscriberSafety:values.customerSafty,
emailPassword:values.password,
otherAccounts:values.otherAccounts,
groups:values.customerGroup.map((group) =>group.id)
}
dispatch(AddGroupUser(customerData, success, error)).then(() => {
  dispatch(LoadSubscribers(
    {
    pageNumber:1,
    pageSize:10
  },error))
})
        
    }


    setOpenForm(false)  
         }

        */
    },
  });

  const setDrawerClose = () => {
    setDrawer(false);
    dispatch(SelectedUser(false));
  };

  const SetCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    dispatch(SelectedUser(false));
  };

  return (
    <>
      {snackbar}

      {messageTypes && NotificationTemplates ? (
        <>
          <Modal
            open={openDeleteModal}
            handleClose={() => SetCloseDeleteModal()}
          >
            <ModalAlerts
              title="Permenantly Delete Customer"
              btnTitle="Delete Customer"
              content={
                "Are you sure you want to delete Customer? data will no longer be restored."
              }
              handleCloseModal={() => SetCloseDeleteModal()}
              action={DeleteCustomer}
            />
          </Modal>

          <Header headLine="Customers List">
            <CustomButton
              text="Add Customer"
              type="add"
              action={handleOpenForm}
            />
          </Header>
          <ModalForm
            title={`Add Customer`}
            handleClose={handleCloseForm}
            open={openForm}
            touched={touched}
            action={() => formik.handleSubmit()}
            Reset={Reset}
          >
            <FormikProvider value={formik}>
              <CustomerForm
                formik={formik}
                NotificationType={notificationType}
                SendingType={sendingType}
                Direction={direction}
                docType={docType}
                saftyType={saftyType}
                customerType={customerType}
                messageTypes={messageTypes}
                NotificationTemplates={NotificationTemplates}
                Groups={Groups}
                defaultTemplate={defaultTemplate}
                setTouched={setTouched}
                touched={touched}
              />
            </FormikProvider>
          </ModalForm>
          {Object.entries(selectedUser).length > 0 && (
            <SideDrawerForm drawer={drawer} setDrawer={setDrawerClose}>
              <SideCustomerForm
                formik={formik}
                customerType={customerType}
                defaultTemplate={defaultTemplate}
                NotificationType={notificationType}
                SendingType={sendingType}
                Direction={direction}
                docType={docType}
                saftyType={saftyType}
                messageTypes={messageTypes}
                NotificationTemplates={NotificationTemplates}
                setTouched={setTouched}
                Groups={Groups}
                touched={touched}
                setDrawer={setDrawerClose}
                CheckStatus={CheckStatus}
                DeleteCustomer={handleDelete}
              />
              {/*<SideMenuContent
          selectedUser={selectedUser}
          setDrawer={setDrawer}
          setSelectedUser={setSelectedUser}
          setSelected={setSelected}
          selectedStatus={selectedStatus}
          deleteUserHandler={deleteUserHandler}
          resetPasswordAction={resetPasswordAction}
          changeUserStatus={changeUserStatus}
          deletePermission
        /> */}
            </SideDrawerForm>
          )}

          <CustomerFilter
            setFilterValue={setFilterValue}
            filterValue={filterValue}
            userStatus={userStatus}
          />
          <CustomersList
            filterValue={filterValue}
            setDrawer={setDrawer}
            error={error}
            success={success}
            Groups={Groups}
          />
        </>
      ) : (
        <ScreenLoader />
      )}
    </>
  );
};

export default Customers;
